import { Route, Redirect, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useContext } from 'react';
import MenuContext from '~/contexts/menuContext';
import CelsiusAiContext from '~/contexts/celsiusAiContext';
import { DesktopNavbar } from '~/components/DesktopNavbar';
import { MobileNavbar } from '~/components/MobileNavbar';
import { apmElastic } from 'helpers/apmElastic';
import { useAuth } from 'react-oidc-context';
import { CHAT_PANEL_WIDTH } from '~/components/CelsiusAIChat/styles';

const PrivateRouteWrapper = styled.div<{ isMenuOpen, isCelsiusOpen }>(
  ({ isMenuOpen, isCelsiusOpen }) => `
  padding: 24px 16px;
  @media (min-width: 768px) {
    padding-top: 70px;
    padding-left: ${isMenuOpen ? '270px' : '90px'};
    padding-right: ${isCelsiusOpen ? `${CHAT_PANEL_WIDTH + 20}px` : '20px'};
    transition: padding-right 0.25s ease;
  }
`,
);

type PrivateRouteProps = {
  component: React.ElementType;
  path: string;
  exact?: boolean;
}

export const PrivateWithRedirectRoute = ({ component: Component, ...params }: PrivateRouteProps): JSX.Element => {
  const { isAuthenticated } = useAuth();
  const { menuToogle } = useContext(MenuContext);
  const { isCelsiusOpen } = useContext(CelsiusAiContext);
  const location = useLocation();
  const path = location.pathname;
  return (
    <>
      <DesktopNavbar />
      <MobileNavbar />
      <PrivateRouteWrapper isMenuOpen={menuToogle} isCelsiusOpen={isCelsiusOpen}>
        <Route
          {...params}
          render={(props) => {
            if (process.env.REACT_APP_APM_ELASTIC) {
              apmElastic(props.location.pathname);
            }
            return isAuthenticated ? <Component {...props} /> : <Redirect to={`/logout?topage=${path}`} />;
          }}
        />
      </PrivateRouteWrapper>
    </>
  );
};
